import { Alert, Box, CircularProgress } from '@mui/material';
import * as React from 'react';

interface CenterSpinnerProps {
  loading: boolean;
  coverW?: boolean; // default true
  coverH?: boolean; // default false
  error?: string; // can be supplied to show only error instead of content
  children?: JSX.Element;
}

export const CenterSpinner = (props: CenterSpinnerProps) => {
  const {
    loading,
    coverW = true,
    coverH = false,
    error,
    children,
  } = props;

  if (!loading) {
    if (error) {
      return (
        <Box sx={{ width: coverW ? '100%' : 'initial', height: coverH ? '100%' : 'initial', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Alert severity='error'>{error}</Alert>
        </Box>
      )
    }

    if (children) {
      return children
    }
    return null
  }

  return (
    <Box sx={{ width: coverW ? '100%' : 'initial', height: coverH ? '100%' : 'initial', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress color="info" />
    </Box>
  )
}